define(function(require) {
    // GEO09E66_TERRI_ANA_PP_FRA layer definition config
    return {
        LAYER_ID : "GEO09E66_TERRI_ANA_PP_FRA",
        LAYER_TYPE : "POLYGON",
        USE_TYPED_ARRAY : true,
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        INDEX : 5,
        DATATABLE_ID : "t_GEO09E66_TERRI_ANA_PP_FRA",
        QUERY_FIELDS : ["CD_TA_PRIM", "CD_CS", 
            //from the joined table
            "NB_PE_40"],
        FIELDS : [
            {ID : "CD_TA_PRIM", NAME : "Code", DATA_TYPE: "STRING", VALUE : "{{CD_TA_PRIM}}"},
            {ID : "CD_CS", NAME : "Code de l'organisme responsable", DATA_TYPE: "STRING", VALUE : "{{CD_CS}}"},
            //from the joined table
            {ID : "NB_PE_40", NAME : "Nombre de classes sur 5 ans (2029-2030) en considérant un taux de fréquentation à la maternelle 4 ans de 40%", DATA_TYPE : "NUMBER", DECIMAL_PLACES: 0, VALUE: "{{NB_PE_40}}"}
        ],
        JOIN_KEY: "TERR_ANA",
        STYLES: [
            {
                ID: "Territoire d’analyse (primaire) francophone, édition PQI",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(128,0,64,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 7
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(128,0,64,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Territoire d’analyse (primaire) francophone, édition PQI 2026-2036",
            FEATURE_ID_DATACOLUMN : "CD_TA_PRIM",
            FEATURE_NAME_DATACOLUMN : "CD_TA_PRIM",
            DATATIP_DATACOLUMNS : ["CD_TA_PRIM"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            //DATAVIEW_DATACOLUMNS : ["CD_TA_PRIM", "CD_CS"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_TA_PRIM", "CD_CS", "NB_PE_40"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_TA_PRIM", "CD_CS"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "CD_TA_PRIM",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false,
            BLEND_MODE : "NORMAL",
        }
    };
});
